export default __webpack_public_path__ + "static/media/notification.2c74c593.svg";